import React from "react";
import PhysicalBanner from "../physicalrecords/PhysicalBanner";
import DataCompliances from "./DataCompliances";
import PhysicalSecurity from "../physicalrecords/PhysicalSecurity";
import DataProtect from "./DataProtect";
import PhysicalDocsLeft from "../physicalrecords/PhysicalDocsLeft";
import PhysicalTool from "../physicalrecords/PhysicalTool";
import PhysicalStorage from "../physicalrecords/PhysicalStorage";
import PhysicalClientLogo from "../physicalrecords/PhysicalClientLogo";
import PhysicalAdopt from "../physicalrecords/PhysicalAdopt";
import PhysicalFaq from "../physicalrecords/PhysicalFaq";

const physicalData = {
  img: "/assets/images/data-platform-banner.webp",
  head: "Bulletproof Compliance for the Modern Enterprise",
  btn: "Contact Us",
  slug: "/contact",
};

const securityData = {
  head: "Your Unified Data Governance & Compliance Hub",
  desc: `<p>Take control of your entire data ecosystem with a cloud-native Bulletproof platform designed for modern privacy, risk, and compliance teams. Automate regulatory workflows, enforce data protection policies, and proactively identify risks through a centralized and intelligent system.</p>`,
  boxes: [
    {
      img: "/assets/images/physical-security-img-1.webp",
      label: "Automated Data Discovery & Mapping"
    },
    {
      img: "/assets/images/physical-security-img-2.webp",
      label: "Continuous Regulatory Monitoring"
    },
    {
      img: "/assets/images/physical-security-img-3.webp",
      label: "Intelligent Policy Enforcement"
    },
    {
      img: "/assets/images/physical-security-img-4.webp",
      label: "Streamlined DSAR Fulfillment"
    },

  ]
}

const accordData2 = {
  head: "Transform Your Information Governance",
  desc: "Build a smarter, more secure approach to managing enterprise data.",
  boxes: [
    {
      head: "Intelligent Content Hub",
      para: 'Automatically capture, classify, manage data from multiple sources. Improve accessibility while reducing manual intervention.',
      img: "/assets/images/data-docs-left-img-1.webp",
    },
    {
      head: "Smart Workflow Engine",
      para: 'Automate governance workflows including approvals, access control, document lifecycle management to ensure consistency and efficiency.',
      img: "/assets/images/data-docs-left.webp",
    },
    {
      head: "Insight Analytics Suite",
      para: 'Gain real-time visibility into data usage, compliance status, risk exposure through advanced analytics and reporting.',
      img: "/assets/images/data-docs-left-img-3.webp",
    },
    {
      head: "Advanced Data Shield",
      para: 'Protect sensitive data with strong encryption, access controls, monitoring systems that safeguard against unauthorized access and breaches.',
      img: "/assets/images/data-docs-left-img-4.webp",
    },
  ]
}

const countData = {
  title: "Streamlined Control with Reduced Overhead",
  para: "Simplify governance operations while improving speed, security, efficiency.",
  btn: "Transform Your Data Operations",
  stats: [
    {
      number: "95",
      suffix: "%",
      desc: "better operational efficiency"
    },
    {
      number: "99",
      suffix: "%",
      desc: "compliance accuracy"
    },
    {
      number: "90",
      suffix: "%",
      desc: "reduced operational costs"
    },
  ]
}

const storageData = {
  head: "Precision Governance and Absolute Data Compliance",
  desc: `<p>Our unified <b>SaaS platform</b> helps enterprises maintain data integrity, achieve <b>regulatory compliance</b>, respond quickly to evolving requirements with confidence.</p>`,
  boxes: [
    {
      img: "/assets/images/physical-storage-icon-1.webp",
      label: "Optimized resource utilization"
    },

    {
      img: "/assets/images/physical-storage-icon-2.webp",
      label: "Reduced system and application complexity"
    },

    {
      img: "/assets/images/physical-storage-icon-3.webp",
      label: "Stronger data governance and security posture"
    },

    {
      img: "/assets/images/physical-storage-icon-4.webp",
      label: "Faster response to audits and information requests"
    },
  ]
}

const adoptData = {
  firstimg: "assets/images/physical-adopt-blur.webp",
  secondimg: "/assets/images/physical-adopt-img1.webp",
  thirdimg: "/assets/images/physical-adopt-img2.webp",
  name: "Ritesh Verma",
  position: "General Manager",
  desc: "Dox and Box streamlined our document workflows and eliminated manual bottlenecks. The system is secure, reliable, easy for teams to adopt. We’ve seen faster turnaround times and better compliance tracking, improving operational efficiency while reducing costs."
}

const faqData = {
  image:"/assets/images/physical-faq-img.webp",
  faqs:[
    {
      question:"What regulations and compliance standards does the platform support?",
      answer:"The platform is designed to support a wide range of regulatory frameworks including data privacy laws, industry-specific compliance standards, internal governance policies. It can be configured to align with your organization’s specific regulatory requirements."
    },
    {
      question:"How does the platform ensure data security?",
      answer:"Data is protected through multiple layers including encryption, role-based access control, continuous monitoring, audit trails. These measures help prevent unauthorized access and ensure complete visibility into data activity."
    },
    {
      question:"Can the platform integrate with our existing systems?",
      answer:"Yes. The platform integrates seamlessly with existing enterprise systems such as ERP, CRM, document management tools, cloud storage platforms to enable smooth data flow and centralized governance."
    },
    {
      question:"How does the platform help with audits and compliance reporting?",
      answer:"The platform automates audit trails, tracks data access and changes, generates real-time compliance reports. This reduces manual effort and ensures you are always prepared for internal and external audits."
    },
    {
      question:"Is the platform scalable for large enterprises?",
      answer:"Absolutely. The platform is built on a scalable architecture that supports growing data volumes, multiple departments, complex workflows without compromising performance or security."
    },
  ]
}

export default function DataPlatform() {
  return (
    <>
      <PhysicalBanner data={physicalData} />
      <DataCompliances />
      <PhysicalSecurity data={securityData} />
      <DataProtect />
      <PhysicalDocsLeft data={accordData2} />
      <div className="data-platform-count">
        <PhysicalTool countData={countData} />
      </div>
      <PhysicalStorage data={storageData} />
      <PhysicalClientLogo />
      <PhysicalAdopt data={adoptData} />
      <PhysicalFaq data={faqData} />
    </>
  )
}
